module.exports = __webpack_public_path__ + "static/media/facebookmessenger.4729c11d.png";